import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { wrapURLs } from '@core/common-legacy';

@Pipe({
  standalone: true,
  name: 'taskTitleWrapUrls',
})
export class TaskTitleWrapUrlsPipe implements PipeTransform {
  public transform(taskTitle: string, targetBlank = true): string {
    return wrapURLs(taskTitle, targetBlank);
  }
}
